import type React from "react"
import "./common-popup.css"
import { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";
import { GetImages } from "../../utils/GetImages";

interface CommonpopupProps {
  isOpen?: boolean
  onClose?: () => void
  component?: ReactNode;
  /** Wider variant (1020px vs the 722px default) for content-heavy popups like tables. */
  wide?: boolean;
}

const Commonpopup: React.FC<CommonpopupProps> = ({
  isOpen,
  onClose,

  component,
  wide,
}) => {
  // Lock background scroll while open, mirroring RightSideModal's own portal pattern.
  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null

  // Prevent SSR errors if document is undefined
  if (typeof document === "undefined") return null

  return createPortal(
    <div className="common-popup-overlay">
      <div className={`common-popup-card ${wide ? "common-popup-card--wide" : ""}`}>
        <button className="common-popup-close-button" onClick={onClose}>
        <img src={GetImages.Blackcross} alt="Close" width={16} height={16} />
        </button>

        <div className="common-popup-scroll-body">
          {component}
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default Commonpopup
